import { assert_string_object_id, assert_type_enum } from '@shared/asserts/utils_asserts';
import { DTO__base } from '@shared/common/DTO__base';
import { DTO__word_with_context } from '@shared/dto/+word/word_translated/DTO__word_with_context';
import { ENUM__workspace_entity } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity';
import { ENUM__language_type } from '@shared/enums/ENUM__language_type';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';

export class RequestWordsTranslateFromEnglish extends DTO__base {
  static _class_name_static: string = ENUM__dto_class_name.REQUEST_WORDS_TRANSLATE_FROM_ENGLISH;

  entity_type!: string;
  entity_id!: string;

  language!: string;
  word_with_context!: DTO__word_with_context;

  /*
   * METHODS
   */

  assert_standard_fields(): void {
    assert_type_enum(this.entity_type, ENUM__workspace_entity);
    assert_string_object_id(this.entity_id);

    assert_type_enum(this.language, ENUM__language_type);
  }
}
